import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { setupAuthInterceptor } from './actions/auth';
import { useStatusAktifCheck } from './hooks/useStatusAktifCheck';
import { useSessionTimeout } from './hooks/useSessionTimeout';
import { Switch, Route, Redirect } from 'react-router';
import { HashRouter } from 'react-router-dom';

import { ConnectedRouter } from 'connected-react-router';
import { getHistory } from './index';
import { AdminRoute, UserRoute, AuthRoute } from './RouteComponents';
import hasToken from './services/authService';

import ErrorPage from './pages/error/ErrorPage.js';
import LayoutComponent from './components/Layout/Layout.js';
import Login from './pages/auth/login/Login';
import Register from './pages/auth/register/Register.js';

import './styles/app.scss';

/** Redirect cerdas: jika login -> dashboard, jika belum -> beranda */
const RootRedirect = () => {
  if (hasToken()) {
    return <Redirect to='/template/dashboard' />;
  }
  return <Redirect to='/beranda' />;
};

const App = (props) => {
  useEffect(() => {
    setupAuthInterceptor();
  }, []);

  useStatusAktifCheck();
  useSessionTimeout();

  return (
    <div>
      <ConnectedRouter history={getHistory()}>
        <HashRouter>
          <Switch>
            {/* Root - redirect berdasarkan status login */}
            <Route path='/' exact render={() => <RootRedirect />} />

            {/* Route publik - halaman login & register */}
            <AuthRoute path='/beranda' exact component={Login} />
            <AuthRoute path='/register' exact component={Register} />

            {/* Route publik - halaman error (selalu bisa diakses) */}
            <Route path='/error' exact component={ErrorPage} />

            {/* Redirect /template ke dashboard */}
            <Route
              path='/template'
              exact
              render={() =>
                hasToken() ? (
                  <Redirect to='/template/dashboard' />
                ) : (
                  <Redirect to='/beranda' />
                )
              }
            />

            {/* Route terlindungi - membutuhkan login */}
            <UserRoute
              path='/template'
              dispatch={props.dispatch}
              component={LayoutComponent}
              currentUser={props.currentUser}
            />

            {/* Redirect /admin ke bantuan */}
            <Route
              path='/admin'
              exact
              render={() =>
                hasToken() ? (
                  <Redirect to='/admin/bantuan' />
                ) : (
                  <Redirect to='/beranda' />
                )
              }
            />

            {/* Route terlindungi admin */}
            <AdminRoute
              path='/admin'
              currentUser={props.currentUser}
              dispatch={props.dispatch}
              component={LayoutComponent}
            />

            {/* Fallback - path tidak dikenal */}
            <Route path='*' render={() => <RootRedirect />} />
          </Switch>
        </HashRouter>
      </ConnectedRouter>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
  loadingInit: state.auth.loadingInit,
});

export default connect(mapStateToProps)(App);
